<div class="px-2 md:px-10 pt-2 md:pt-5 font-bold overflow-y-auto h-74 md:h-88">
  <h1 class="w-full text-center text-3xl mb-10">🚧 Évolution de nos services en cours</h1>

  <h2 class="text-primary_text text-center text-xl mb-10">
    <strong>Cher adhérent,</strong>
    <p>Nous améliorons votre espace adhérent pour mieux vous servir.</p>
    <p class="mt-3">
      Vos contrats et informations personnelles restent sécurisés et seront accessibles très prochainement.
    </p>
  </h2>
</div>
